import Item, { TagItemProps } from './components/Item';

export const Tag = {
  Item,
};

export type TagProps = {
  ItemProps: TagItemProps;
};
